<div class="row mt-4">
	<div class="col-xs-12 col-md-6">
		<app-documentos-emitidos-widget></app-documentos-emitidos-widget>
		<app-folios-widget></app-folios-widget>	
	</div>
	<div class="col-xs-12 col-md-6">
		<app-noticias-widget></app-noticias-widget>
	</div>
</div>
<div class="row mt-5">
	<div class="col-12">
		
	</div>
</div>
